/* Kessoro cart drawer upsell (v17) + Shipping Protection toggle (v52).
   Uses event delegation on document, so it keeps working after the drawer HTML is re-rendered
   by cart.js / cart-drawer.js. Adds via /cart/add.js with bundled section rendering and hands the
   fresh drawer HTML to the theme's own cart-drawer.renderContents(). */
(function () {
  if (window.kdCartInit) return;
  window.kdCartInit = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function onVariantChange(select) {
    var card = select.closest('[data-kd-card]');
    var opt = select.options[select.selectedIndex];
    if (!card || !opt) return;
    var price = card.querySelector('[data-kd-price]');
    var compare = card.querySelector('[data-kd-compare]');
    var img = card.querySelector('[data-kd-img]');
    if (price) price.textContent = opt.getAttribute('data-price');
    if (compare) {
      var c = opt.getAttribute('data-compare');
      compare.textContent = c || '';
      compare.hidden = !c;
    }
    var src = opt.getAttribute('data-img');
    if (img && src) img.src = src;
  }

  function addToCart(button) {
    var card = button.closest('[data-kd-card]');
    var select = card && card.querySelector('[data-kd-variant]');
    var error = card && card.querySelector('[data-kd-error]');
    if (!select || !select.value) return;
    var id = parseInt(select.value, 10);

    button.disabled = true;
    button.classList.add('is-loading');
    if (error) { error.hidden = true; error.textContent = ''; }

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: id, quantity: 1 }],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok || res.data.status) {
          throw new Error((res.data && (res.data.description || res.data.message)) || 'Could not add this item.');
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function' && res.data.sections) {
          drawer.renderContents({ id: id, sections: res.data.sections });
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function (e) {
        if (error) { error.textContent = e.message; error.hidden = false; }
        button.disabled = false;
        button.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-kd-nav]');
    if (nav) {
      var wrap = nav.closest('[data-kd-upsell]');
      var track = wrap && wrap.querySelector('[data-kd-track]');
      if (!track) return;
      var dir = nav.getAttribute('data-kd-nav') === 'next' ? 1 : -1;
      var max = track.scrollWidth - track.clientWidth;
      var target;
      if (dir > 0 && track.scrollLeft >= max - 2) target = 0;          // at the end: wrap to start
      else if (dir < 0 && track.scrollLeft <= 2) target = max;        // at the start: wrap to end
      else target = Math.max(0, Math.min(max, track.scrollLeft + dir * track.clientWidth));
      track.scrollTo({ left: target, behavior: 'smooth' });
      return;
    }
    var add = e.target.closest('[data-kd-add]');
    if (add) {
      e.preventDefault();
      addToCart(add);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('[data-kd-variant]')) onVariantChange(e.target);
    if (e.target.matches && e.target.matches('[data-kd-protect-toggle]')) onProtectToggle(e.target);
  });

  /* ---------- v52: Shipping Protection ---------- */
  var DECLINED_KEY = 'kdProtectDeclined';

  function cartRequest(path, body) {
    return fetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(Object.assign({ sections: 'cart-drawer,cart-icon-bubble', sections_url: window.location.pathname }, body))
    }).then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); });
  }

  function rerender(res) {
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function' && res.data.sections) {
      drawer.renderContents({ sections: res.data.sections });
      if (res.data.item_count === 0) {
        drawer.classList.add('is-empty');
        var items = drawer.querySelector('cart-drawer-items');
        if (items) items.classList.add('is-empty');
      }
    }
  }

  function onProtectToggle(input) {
    var wrap = input.closest('[data-kd-protect]');
    if (!wrap) return;
    var variantId = parseInt(wrap.getAttribute('data-variant-id'), 10);
    var inCart = parseInt(wrap.getAttribute('data-in-cart'), 10) > 0;
    input.disabled = true;
    var req;
    if (input.checked && !inCart) {
      try { sessionStorage.removeItem(DECLINED_KEY); } catch (err) {}
      req = cartRequest('cart/add.js', { items: [{ id: variantId, quantity: 1 }] });
    } else if (!input.checked && inCart) {
      try { sessionStorage.setItem(DECLINED_KEY, '1'); } catch (err) {}
      req = cartRequest('cart/change.js', { id: String(variantId), quantity: 0 });
    } else {
      input.disabled = false;
      return;
    }
    req.then(function (res) {
      if (!res.ok || res.data.status) throw new Error('Could not update shipping protection.');
      rerender(res);
    }).catch(function () {
      input.checked = inCart;
      input.disabled = false;
    });
  }

  /* Keep the protection line consistent with the rest of the cart:
     - if it is the only thing left, drop it (an order of just protection makes no sense);
     - if default-on is enabled and the customer has not switched it off, add it to a new cart. */
  function reconcileProtection() {
    var wrap = document.querySelector('[data-kd-protect]');
    var variantId = wrap ? parseInt(wrap.getAttribute('data-variant-id'), 10) : null;
    var defaultOn = wrap && wrap.getAttribute('data-default-on') === 'true';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var prot = null, others = 0;
        (cart.items || []).forEach(function (it) {
          if (it.handle === 'shipping-protection') prot = it; else others += it.quantity;
        });
        if (prot && others === 0) {
          return cartRequest('cart/change.js', { id: String(prot.variant_id), quantity: 0 }).then(rerender);
        }
        var declined = false;
        try { declined = sessionStorage.getItem(DECLINED_KEY) === '1'; } catch (err) {}
        if (!prot && others > 0 && defaultOn && variantId && !declined) {
          return cartRequest('cart/add.js', { items: [{ id: variantId, quantity: 1 }] }).then(rerender);
        }
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(reconcileProtection, 150); });
  }
  document.addEventListener('DOMContentLoaded', reconcileProtection);
})();
